import {createSlice, type PayloadAction} from "@reduxjs/toolkit";
import type {Address} from "@/types";

export type ThemePreference = "light" | "system" | "dark";
const DEFAULT_THEME: ThemePreference = "system";
const isThemePreference = (value: string | null): value is ThemePreference =>
    value === "light" || value === "system" || value === "dark";

export interface MainState {
    theme: ThemePreference;
    collapseSidebar: boolean;
    showAddAddressModal: boolean;
    toBeEditedAddress?: Address;
    showAddPaymentModal: boolean;

}

const initialState: MainState = {
    collapseSidebar: false,
    showAddPaymentModal: false,
    showAddAddressModal: false,
    theme: isThemePreference(localStorage.getItem("theme")) ? localStorage.getItem("theme") as ThemePreference : DEFAULT_THEME

}


const mainSlice = createSlice({
    name: 'main',
    initialState,
    reducers: {
        setTheme(state, action: PayloadAction<ThemePreference>) {
            state.theme = action.payload;
            localStorage.setItem("theme", action.payload);
        },
        setCollapseSidebar(state, action: PayloadAction<boolean>) {
            state.collapseSidebar = action.payload;
        },
        setShowAddAddressModal(state, action: PayloadAction<boolean>) {
            state.showAddAddressModal = action.payload;
            if (!action.payload) state.toBeEditedAddress = undefined;
        },
        setToBeEditedAddress(state, action: PayloadAction<Address>) {
            state.toBeEditedAddress = action.payload;
        },
        setShowAddPaymentModal(state, action: PayloadAction<boolean>) {
            state.showAddPaymentModal = action.payload;
        }
    }
});
export const {setTheme,setShowAddAddressModal,setShowAddPaymentModal,setToBeEditedAddress,setCollapseSidebar} = mainSlice.actions
export default mainSlice;
